module.exports = __webpack_public_path__ + "img/copy.9752db97.svg";